import * as Only from './breakpoints';
import * as TypoInternal from './Typo';
import * as AvatarTypo from './AvatarTypo';
import * as Button from './Buttons';


export { Accordion, Accordions } from './Accordion';
export { default as Body } from './Layout/Body';
export { default as Card } from './Card';
export { default as Media } from './Media';
export { default as CompanyAvatar } from './Avatar/CompanyAvatar';
export { default as ThreadAvatar } from './Avatar/ThreadAvatar';
export { default as MessageAvatar } from './Avatar/MessageAvatar';
export { default as Cookies } from './Cookies';
export { default as Drop } from './Drop';
export { default as ErrorBoundary, MainErrorBoundary } from './ErrorBoundary';
export { default as ErrorLayout } from './ErrorLayout';
export { default as ErrorScreen } from './ErrorScreen';
export { default as Faq } from './Faq';
export { default as FormatDate } from './FormatDate';
export { default as Icon } from './Icons/Icon';
export { default as Content } from './Layout/Content';
export { default as Navigation } from './Navigation/Navigation';
export { default as AddApplicationSmokeTest } from './SmokeTest/AddApplicationSmokeTest';
export { default as Paragraph } from './Paragraph';
export { default as Pill } from './Pill';
export { default as ScrollToTop } from './ScrollToTop';
export { default as Spinner } from './Spinner';
export { default as Switch, Case, Default } from './Switch';
export { TopBar } from './topbar';
export { default as Modal } from './Modal';
export { default as SlideSwitch } from './SlideSwitch';
export { default as Checkbox } from './Checkbox';
export { default as Scrollbars } from './Scrollbars';
export { default as Separator } from './Separator';
export { default as UnreadCounter } from './UnreadCounter';
export { default as Input } from './Input';

export { default as Tooltip } from './Tooltip';
export { default as Recommendations } from './Recommendations';
export { default as SystemNotificationPopup } from './SystemNotificationPopup/SystemNotificationPopup';


const Typo = {
    ...TypoInternal,
    Avatar: AvatarTypo
};

export { Button };
export { Only };
export { Typo };
